module.exports = [{
      plugin: require('/Users/minghuasun/Documents/Github/budget/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-MXQVJQ7","includeInDevelopment":false},
    },{
      plugin: require('/Users/minghuasun/Documents/Github/budget/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/minghuasun/Documents/Github/budget/budgets/summary/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
